import React from "react";

const StaffmanagementIcon = () => {
  return (
<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.25 14.5H14M8 12.5V9.14289C8 9.14289 6.5 8.28575 4.5 8.28575C2.5 8.28575 1.25 9.14289 1.25 9.14289V12.5715M10.5 1V3.78571H8.5V5.5H10.5V8H12V5.5H14V3.78571H12V1H10.5ZM4.5 7.5C4.5 7.5 2.5 6.14403 2.5 4.89489C2.5 3.92861 3.671 2.5 4.5 2.5C5.329 2.5 6.5 3.92861 6.5 4.89489C6.5 6.14289 4.5 7.5 4.5 7.5Z" stroke="white"/>
</svg>





    
    
  );
};

export default StaffmanagementIcon;
